import ListItemIcon from "@material-ui/core/ListItemIcon";
import PlaceTwoToneIcon from "@material-ui/icons/PlaceTwoTone";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

function LocationListItemSkeleton() {
  return (
    <ListItem style={{ paddingRight: 95 }}>
      <ListItemIcon>
        <PlaceTwoToneIcon />
      </ListItemIcon>
      <ListItemText
        primary={<Skeleton width={120} />}
        secondary={<><Skeleton width={120} /><Skeleton width={120} /></>}
      />
    </ListItem>
  );
}

export default LocationListItemSkeleton;
